import { Link } from 'react-router-dom';
import bannerImage from '../assets/img/about_img.jpg';

export default function AboutPreview() {
  return (
    <section className="relative overflow-hidden bg-navy-950 py-16 sm:py-24" aria-labelledby="about-preview-heading">
      <div
        className="pointer-events-none absolute inset-0 z-[1] bg-gradient-to-br from-navy-950 via-navy-950/88 to-navy-900/55"
        aria-hidden
      />
      <div className="relative z-10 mx-auto grid max-w-7xl items-center gap-10 px-4 sm:px-6 lg:grid-cols-2 lg:gap-14 lg:px-8">
        <div>
          <h2
            id="about-preview-heading"
            className="font-sans text-3xl font-bold tracking-tight text-white md:text-4xl"
          >
            About{' '}
            <span className="font-serif text-3xl font-semibold italic text-gold md:text-4xl">Preview</span>
          </h2>
          <div className="mt-4 h-px w-16 bg-gradient-to-r from-transparent via-gold/80 to-transparent" aria-hidden />
          <p className="mt-6 text-justify font-normal leading-relaxed text-white/80">
            RAYAN STAR Consultancy &amp; Services W.L.L., established in August 2015 in Manama, Bahrain,
            is a fast-growing consultancy driven by expertise, professionalism, and ambition. Although a
            young company, we are backed by a team of highly experienced professionals with decades of
            combined experience in government documentation, education consultancy, travel &amp; tourism,
            visa services, and event management.
          </p>
          <Link
            to="/about"
            className="mt-8 inline-flex items-center gap-2 rounded-md bg-gold px-6 py-3 font-sans text-sm font-semibold tracking-wide text-navy shadow-sm transition hover:bg-gold-light"
          >
            Read More
            <span aria-hidden>→</span>
          </Link>
        </div>
        <div className="overflow-hidden rounded-2xl border border-slate-200/80 shadow-lg shadow-navy/10 ring-1 ring-gold/20">
          <img
            src={bannerImage}
            alt="Manama skyline at night"
            className="h-full w-full object-cover object-center"
          />
        </div>
      </div>
    </section>
  );
}
